import React from 'react';
import clsx from 'clsx';
import InCellDivisionBlock from 'components/common/group/content/InCellDivisionBlock';
import { InstalledEnrollmentType } from 'types/enrollmentService';
import { createStyles } from '../styles';

const DynamicCell = (
  periods: InstalledEnrollmentType[],
  selectedPeriods: InstalledEnrollmentType[],
  cellType: string,
  generateContent: (period: InstalledEnrollmentType) => JSX.Element | string,
): (JSX.Element | null)[] => {
  const classes = createStyles();
  return periods.map((enrollmentPeriod, index) => {
    const isPeriodSelected = selectedPeriods.some((selectedPeriod) => selectedPeriod.id === enrollmentPeriod.id);

    const cellKey = enrollmentPeriod.effectiveDate ? `${cellType}-${enrollmentPeriod.effectiveDate}` : index;
    return enrollmentPeriod.productLineIds.length > 0 ? (
      <InCellDivisionBlock
        withBorder
        className={clsx(classes.customInCellBlock, isPeriodSelected && classes.selectedCellBlock)}
        key={cellKey}
      >
        {generateContent(enrollmentPeriod)}
      </InCellDivisionBlock>
    ) : null;
  });
};

export default DynamicCell;
